import styled, { StyledComponent } from '@emotion/styled';
import { display, DisplayProps, height, HeightProps, width, WidthProps, color, ColorProps, space, SpaceProps } from 'styled-system';
import { ComponentProps, FC } from 'react';

type HorizontalRuleProps = DisplayProps & HeightProps & WidthProps & ColorProps & SpaceProps;

const Hr: StyledComponent<ComponentProps<'hr'>, HorizontalRuleProps, any> = styled.hr`
  border: 0;
  ${display}
  ${width}
  ${height}
  ${width}
  ${color}
  ${space}
`;

const HorizontalRule: FC<ComponentProps<'hr'> & HorizontalRuleProps> = (props) => <Hr height="borderThin" bg="greys.alto" {...props} />;

HorizontalRule.displayName = 'HorizontalRule';

export default HorizontalRule;
